module.exports = __webpack_public_path__ + "img/antes_despues_277.2a9da24d.png";